'use strict';
/**
 * @name masterDataPaymentMethodsCtrl
 * @desc Controller for master data payment methods controller
 */
function masterDataPaymentMethodsCtrl($scope, $stateParams, toastr, dataList,
                                      paymentMethodsMasterDataList, $uibModal, globalFunc,
                                      $location,pathConstants) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.paymentMethodService = paymentMethodsMasterDataList;

  $scope.addPaymentMethod = addPaymentMethod;
  $scope.editPaymentMethod = editPaymentMethod;
  $scope.search = search;
  $scope.showColumn = showColumn;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.params = {};
  $scope.duplicationCheck = duplicationCheck;
  $scope.importPaymentMethod = importPaymentMethod;
  $scope.importLink = pathConstants.apiUrls.paymentMethods.import;

  $scope.columns =
    [
      {id: 'code', label: 'Code'},
      {id: 'descr', label: 'Description'},
      {id: 'updated_at', label: 'Updated At'},
      {id: 'updater.display_name', label: 'Updated By'},
      {id: 'created_at', label: 'Created At'},
      {id: 'creator.display_name', label: 'Created By'},
      {id: 'is_active', label: 'Status'}
    ];

  $scope.storageKey = 'master-data-payment-methods-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function search(query) {
    $location.search({query: query});
  }

  function addPaymentMethod() {
      paymentMethodsMasterDataList.post(
        {
        },
        {
          code: $scope.paymentMethods.code,
          descr: $scope.paymentMethods.descr
        }
        ,
        function (resource) {
          toastr.success('Payment method has been added');
          if(!!resource.content && !!resource.content.data) {
            var addedPaymentMethod = resource.content.data;
            $scope.dataList.unshift({
              _id: addedPaymentMethod._id,
              code: addedPaymentMethod.code,
              descr: addedPaymentMethod.descr,
              created_at: addedPaymentMethod.created_at,
              updated_at: addedPaymentMethod.updated_at,
              updater: [$scope.user],
              creator: [$scope.user],
              is_active: 1
            });
          }
        },
        function (err) {
          globalFunc.objectErrorMessage(err);
        });
  }

  function editPaymentMethod(paymentMethod){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/paymentMethods/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'paymentMethodDetailsCtrl',
      scope: $scope,
      size: 'lg',
      resolve:{
        modalPaymentMethod: function($q,singlePaymentMethod){
          var deferred = $q.defer();
          singlePaymentMethod.get(
            {
              id: paymentMethod._id
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  function importPaymentMethod() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Payment Method';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function initialize(){
    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  initialize();

}

masterDataPaymentMethodsCtrl.$inject = [
  '$scope', '$stateParams', 'toastr', 'dataList', 'paymentMethodsMasterDataList',
  '$uibModal', 'globalFunc', '$location', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('masterDataPaymentMethodsCtrl', masterDataPaymentMethodsCtrl);
